/**
 * Created by jonas on 2020-03-18.
 */
import {
    GameIntroColors,
    GameIntroViewConfig,
    StampConfig,
    Volatility
} from "@nolimitcity/slot-launcher/bin/plugins/concreteplugins/nolimitgameintro/GameIntroView";

import {ImgLoader} from "@nolimitcity/slot-launcher/bin/loader/ImgLoader";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {SlideShowPage} from "@nolimitcity/slot-launcher/bin/gui/views/slideshow/SlideShowPage";
import {SlotGame} from "@nolimitcity/slot-game/bin/SlotGame";

export class DasUBootIntroConfig implements GameIntroViewConfig {

    colors:GameIntroColors = {
        slideShowColors:{
            backgroundColor:0x000000, //Default 0x000000
            backgroundAlpha:0.4, //Default 0.4
            bulletColor:0xffffff, //Default 0xffffff

        },
        stampColor:0xFFFFFF
    };

    stampConfig:StampConfig = {
        xWays:true,
        xNudge:true,
        xBomb:true,
        volatility:Volatility.EXTREME
    };

    background:PIXI.Container;
    borderBottom:PIXI.Container;
    borderTop:PIXI.Container;
    logo:PIXI.Container;
    pages:SlideShowPage[];

    constructor() {
    }

    public init():Promise<GameIntroViewConfig> {
        const imgLoader = new ImgLoader(NolimitApplication.resourcePath);
        imgLoader.add("introBg", "resources/images/background.jpg");
        imgLoader.add("introDiv", "resources/images/divider.png");
        imgLoader.add("feature1", "resources/images/introImage_1.png");
        imgLoader.add("feature2", "resources/images/introImage_2.png");
        imgLoader.add("feature3", "resources/images/introImage_3.png");

        imgLoader.add("logo", "resources/images/introLogo.png");

        return imgLoader.load().then(value => {
            this.initGraphics();
            return this;
        });
    }

    private initGraphics() {
        this.background = new PIXI.Container();
        const bgSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introBg"));
        bgSprite.anchor.set(0.5, 0.5);
        this.background.addChild(bgSprite);

        this.borderTop = new PIXI.Container();
        const topSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        topSprite.anchor.set(0.5, 0.5);
        this.borderTop.addChild(topSprite);

        this.borderBottom = new PIXI.Container();
        const bottomSprite = new PIXI.Sprite(ImgLoader.getImgTexture("introDiv"));
        bottomSprite.rotation = Math.PI;
        bottomSprite.anchor.set(0.5, 0.5);
        this.borderBottom.addChild(bottomSprite);

        this.logo = new PIXI.Container();
        const logoSprite = new PIXI.Sprite(ImgLoader.getImgTexture("logo"));
        logoSprite.anchor.set(0.5, 0.5);
        this.logo.addChild(logoSprite);



        const featureSprite1 = new PIXI.Sprite(ImgLoader.getImgTexture("feature1"));
        featureSprite1.anchor.set(0.5,0.5);

        const featureSprite2 = new PIXI.Sprite(ImgLoader.getImgTexture("feature2"));
        featureSprite2.anchor.set(0.5,0.5);

        const featureSprite3 = new PIXI.Sprite(ImgLoader.getImgTexture("feature3"));
        featureSprite3.anchor.set(0.5,0.5);



        this.pages = [
            new SlideShowPage(),
            new SlideShowPage(),
            new SlideShowPage()
        ];


        this.pages[0].addChild(featureSprite1);
        this.pages[1].addChild(featureSprite2);
        this.pages[2].addChild(featureSprite3);

/*
        this.pages = [
            new SlideShowPage(ImgLoader.getImgTexture("feature1"), SlotGame.apiPlugin.translations.translate("First page")),
            new SlideShowPage(ImgLoader.getImgTexture("feature2"), "obmentaires, d'augmenter le multiplicateur et d'ajouter des lignes arc-en-ciel dans Rainbow Spins "),
            new SlideShowPage(ImgLoader.getImgTexture("feature3"), "Les purs supplémentaires, d'aueur et d'ajouter des lignes arc-en-ciel dans Rainbow Spins "),
            new SlideShowPage(ImgLoader.getImgTexture("feature5"), "Les pièces permettent d'obtenir des tours supplémentaires, d'augmenter le multiplicateur et d'ajouter des lignes arc-en-ciel dans Rainbow Spins ")
        ];*/
    }
}